'use client';

import styled from 'styled-components';

import type { HeadingThreeElementType } from '@zoomit/editor';
import { Typography } from '@zoomit/zoomit-ds';

import { isMobile } from '../../../constants/media-query';
import HeadingLink from './HeadingLink';

interface RenderElementProps {
  children: any;
  element: HeadingThreeElementType;
  id?: string;
}

const HeadingThree = (props: RenderElementProps) => {
  const { children, element, id } = props;

  return (
    <Root>
      {!isMobile && id && <HeadingLink id={id} />}
      <HeadingThreeBase
        variant="h3"
        lineHeight={1.78}
        textAlign={element.annotations.textAlign}
        textDir={element.annotations.textDirection}
        id={id}
      >
        {children}
      </HeadingThreeBase>
    </Root>
  );
};

export default HeadingThree;

type HeadingThreeProps = {
  textAlign?: string;
  textDir?: string;
};

const Root = styled.div`
  position: relative;

  &:hover {
    & > div {
      visibility: visible;
      opacity: 1;
    }
  }
`;

const HeadingThreeBase = styled(Typography)<HeadingThreeProps>`
  font-size: 2rem;
  scroll-margin: 6.8rem;
  margin: 0;
  text-align: ${({ textAlign }) => textAlign};
  direction: ${({ textDir }) => textDir};
`;
